import React from 'react';
import { StyledContent } from './styled';

const RawContent = ({content, children}) => content ? (
  <StyledContent dangerouslySetInnerHTML={{__html: content}} />
) : (
  <StyledContent>
    {children}
  </StyledContent>
);

export default RawContent;



// WEBPACK FOOTER //
// ./src/elements/util/RawContent/RawContent.jsx